import { Subscription, of, fromEvent, merge, timer } from 'rxjs';
import { first, switchMapTo } from 'rxjs/operators';
import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

@Injectable()
export class IdleService implements OnDestroy {
  private subscription: Subscription;
  public onTimeout = new EventEmitter<void>();
  constructor() {
  }
  start(timeout: number) {
    this.stop();
    this.subscription = merge(
      of(null),
      fromEvent(window, 'mousedown'),
      fromEvent(window, 'mousemove'),
      fromEvent(window, 'mousewheel'),
      fromEvent(window, 'touchstart'),
      fromEvent(window, 'touchmove'),
      fromEvent(window, 'scroll'),
      fromEvent(window, 'keydown')
    )
    .pipe(
      switchMapTo(timer(timeout)),
      first()
    )
    .subscribe(() => this.onTimeout.emit());
  }
  stop() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  ngOnDestroy() {
    this.stop();
  }
}
